import React, {useState} from "react";
import axios from "axios";
import __ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import { InputLabel, Chip, Popover, Grid, Typography} from "@material-ui/core";
import { AddOutlined} from "@material-ui/icons";
import { getApiSitePrefix } from "../functions/SiteDefaults";
import { Alert, Form, MaskedNumber } from ".";

const apiSitePrefix = getApiSitePrefix();


const UnNumberSelect = (props) => {

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    chipWithNoLabel: {
      margin: 2,
      '& .MuiChip-labelSmall': {
        paddingRight: 0,
      }
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    menuPaper: {
      maxHeight: 500
    }
  }));

  const {id, label, readOnly, disabled, onChange, values} = props;
  const [oldValues, setOldValues] = useState(values);
  const [valuesArray, setValuesArray] = useState(values || []);
  const [addUnNumberEl, setAddUnNumberEl] = useState(null);
  const [currentShippingName, setCurrentShippingName] = useState(null);
  const showSelector = Boolean(addUnNumberEl);

  if (values !== oldValues) {
    setValuesArray(values);
    setOldValues(values);
  }
  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }

  const className = classNames.join(" ");
  const classes = useStyles();

  const handleAdd = (event) => {
    setAddUnNumberEl(event.currentTarget);
    setCurrentShippingName(null);
  };

  const handleDelete = ({value, position}) => {
    const values = [...valuesArray];
    values.splice(position,1);
    setValuesArray(values);
    if (onChange) {
      onChange(values);
    }
  }

  const handleSelectCompounds = (record) => {
    const unNumber = __.pick(record,
      ['unNumber']);
    const values = [...valuesArray, unNumber.unNumber];
    setAddUnNumberEl(null);
    setValuesArray(values);
    if (onChange) {
      onChange(values);
    }
  }

  const handleCloseSelector = () => {
    setAddUnNumberEl(null);
  };

  const isUnNumberValid = async (ubNumber) => {
    try {
      const response = await axios.get(`${apiSitePrefix}/unnumbers/list/${ubNumber}`);
      if (response.data && Array.isArray(response.data)) {
        if (response.data.length > 0) {
          setCurrentShippingName(`${response.data[0].shippingName} (${response.data[0].class})`);
          return true
        } else {
          setCurrentShippingName(null);
          return false;
        }
      } else {
        setCurrentShippingName(null);
        console.log(`Could not retrieve UN Number. Server is not responding as expected`);
        // SystemData.alert("Error", `Could not retrieve ${moduleName} Template. Server returned ${response.data.error}`);
        return false;
      }
    } catch (err) {
      setCurrentShippingName(null);
      console.log(`Could not retrieve UN Number. Server is not responding. ${err}`);
      // SystemData.alert("Error", `Could not retrieve ${moduleName} Template. Server is not responding`);
      return false;
    }

    return false;
  }

  const Validator = (props) => {
    const record = props?.record;

    const [state, setState] = useState({
      error: null,
      errorMessage: null
    });

    let error = false;
    let errorMessage = "";

    if (!error && !record.unNumber) {
      error = true;
      errorMessage = "A valid 'Compound' number is required";
    }
    if (!error && record.unNumber && ((Number(record.unNumber) < 1 || Number(record.unNumber > 3699)) || !record.isValid)) {
      error = true;
      errorMessage = `${record.unNumber} is not a valid UN Number`;
    }

    if (error !== state.error || errorMessage !== state.errorMessage) {
      setState({ ...state, error, errorMessage });
      if (props.onChange) {
        props.onChange({ error, errorMessage });
      }
    }

    return (
      <Alert open={error} severity="error" message={errorMessage}/>
    );
  }

  return (
    <div className={className}>
      {label
        ?
          <InputLabel shrink id={`${id}-label`} style={{position: "relative", marginBottom: 10}} >{label}</InputLabel>
        :
          <></>
      }
      <div className={classes.chips} style={{...props.chipsStyle}}>
        {valuesArray.map((record, i) => (
          <Chip
            key={i}
            label={`UN${record}`}
            className={classes.chip}
            style={{...props.chipStyle}}
            size={"small"}
            onDelete={readOnly||disabled?null:()=>handleDelete({record, position: i})}
          />
        ))}
        {readOnly||disabled
          ?
            <></>
          :
            <Chip
              key={'add'}
              color="primary"
              icon={<AddOutlined/>}
              className={classes.chipWithNoLabel}
              style={{...props.chipStyle}}
              size={"small"}
              onClick={(e)=>handleAdd(e)}
            />
        }
        {readOnly||disabled
          ?
            <></>
          :
            <Popover
              id={id}
              open={showSelector}
              anchorEl={addUnNumberEl}
              onClose={handleCloseSelector}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <Form key="form"
                open={true}
                record={{unNumber: null, isValid: false}}
                validator={Validator}
                validatorPosition="bottom"
                validatorStyle={{padding: 0}}
                formBodyStyle={{maxHeight: "calc(100vh - 320px)", maxWidth: 300, width: 300}}
                buttonBarStyleOverride={{position: "relative", width: "calc(100% - 30px)", marginTop: -30}}
                buttons = {
                  {
                    save:{icon: "check_circle", key: "Add", label: "Add", color: "primary", disabled: (status)=>{return status.error}},
                    cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
                  }
                }

                onChange={(state) => {
                  if (state.buttonPressed === "cancel") {
                    handleCloseSelector()
                  }
                  if (state.buttonPressed === "save") {
                    const record = state.record;
                    handleSelectCompounds(record);
                  }
                }}
              >
                <div style={{paddingBottom: 20}}>
                  <div style={{padding: "10px 0px"}}>
                    <Typography sx={{ p: 2 }}>Select Compound UN Number</Typography>
                  </div>
                  <Grid container checkChildren={true} spacing={3}>
                    <Grid item xs={12} checkChildren={true}>
                      <MaskedNumber
                        id="unNumber"
                        // label="Compound UN Number"
                        format={"#".repeat(4)}
                        inputLabelProps={{shrink: true}}
                        decimalScale={0}
                        fixedDecimalScale={true}
                        fullWidth
                        isNumericString
                        onChange={async (value, props) => {
                          if (value && value.length > 3) {
                            let isValid = Number(value) > 0 && Number(value) < 3699;
                            isValid = isValid && await isUnNumberValid(value);
                            const data = {
                              ...props.record,
                              unNumber: value,
                              isValid
                            }
                            props.recordChange(data);
                          } else {
                            setCurrentShippingName(null);
                            const data = {
                              unNumber: value,
                              isValid: false
                            }
                            props.recordChange(data);
                          }
                        }}
                      />
                    </Grid>
                    {currentShippingName
                      ?
                        <Grid item xs={12} checkChildren={true}>
                          <div style={{padding: "2px 0px"}}>
                            <Typography sx={{ p: 2 }}>{`${currentShippingName ?? ``}`}</Typography>
                          </div>
                        </Grid>
                      :
                        <></>
                    }
                  </Grid>
                </div>
              </Form>
            </Popover>
        }
      </div>
    </div>
  );
}

export default UnNumberSelect;
